<template>
  <el-container class="page-enter">
    <el-header
      class="header"
      ref="layoutTop"
    >
      <el-row>
        <el-col
          :span="8"
          class="title"
          style="
            text-align: left;
          "
        >
          <span class="title"> 
            乡村振兴税收优惠政策数据上传系统</span>
        </el-col>
        <el-col :span="12">
          <MenuTop
            ref="menuTop"
            @top-change="topChange"
          />
        </el-col>
        <el-col
          :span="4"
          style="text-align: right;"
        >
          <span class="user-avatar" @click="userSet" title="个人设置">.</span>
          <span class="user-name">{{userName}}</span>
          |
          <el-dropdown>
            <i
              class="el-icon-setting"
              style="margin-right: 15px; cursor: pointer; color: #fff;"
            ></i>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item>
                <span @click="userSet">个人设置</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="onLogout">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown>
            <i @click="windowSet"
              class="el-icon-menu" title="窗口全屏切换"
              style="margin-right: 0px; cursor: pointer; color: #fff;"
            ></i>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-header>
    <el-container style="height: calc( 100% - 67px );">
      <el-aside
        ref="layoutLeft"
        v-show="isShowLeft"
        width="200px"
        style="background: #F5F5F5;"
      >
        <!-- 左侧菜单 -->
        <MenuLeft v-bind:data="leftMenuData" />
      </el-aside>
      <el-main>
        <router-view v-on:setShowLeft="setShowLeft" />
      </el-main>
      <el-dialog
        width="850px"
        height="550px"
        :visible.sync="dialogUserSetVisible"
        :destroy-on-close="true"
      >
        <div class="demo-dialog-content">
          <UserDialog
            v-if="dialogUserSetVisible"
            @back="back"
            v-bind:entity="entityData"
            ref="itemPanel"
            show-close="true"
          ></UserDialog>
        </div>
        <el-row></el-row>
      </el-dialog>
    </el-container>
  </el-container>
  
</template>
<script>
import MenuTop from "@/modules/02.console/MenuTop.vue";
import MenuLeft from "@/modules/02.console/MenuLeft.vue";
import UserDialog from "@/modules/02.console/UserDialog.vue";
//import menuData from "./menuData.js";
import menuData from "@/router/menuData.js";
import _ from "lodash";

let menuDataText = sessionStorage.getItem("menu.data");
if (menuDataText) {
  _md = JSON.parse(menuDataText);
}
const w = {
  components: {
    MenuTop,
    MenuLeft,
    UserDialog
  },
  data() {
    return {
      isShowLeft: false,
      leftMenuData: {},
      //menu: menuData,
      userName: "",
      menuIndex: "",
      dialogUserSetVisible:false,
      entityData:{}
    };
  },
  methods: {
    onLogout() {
      console.log("logout");
      sessionStorage.clear();
      //   sessionStorage.removeItem("token");
      //   sessionStorage.removeItem("menu.top.active");
      this.$router.push("/login");
    },
    windowSet(){
      if(this.menuIndex == "1"){
          return;
      }  
      this.isShowLeft = !this.isShowLeft;
    },
    userSet(){
      this.dialogUserSetVisible=true;
    },
    back(){
      this.dialogUserSetVisible=false;
    },
    topChange: function (index, click) {
      console.log(index, click);
      this.menuIndex = index;
      if (index == 1) {
        this.isShowLeft = false;
        this.$router.push("/index");
        return;
      } else {
        this.isShowLeft = true;
      }

      let topName = "0" + index;
      /*
      let leftMenuData = this.menu[topName].left;
      /*/
      let leftMenuData = this.getLeftMenuData(index);
      //*/
      this.leftMenuData = leftMenuData;

      if (click) {
        let path = ((menuData) => {
          try {
            let t = menuData[0];
            if (t.path) {
              return t.path;
            }
            return t.children[0].path;
          } catch (e) {
            this.isShowLeft = false;
            return "index";
          }
        })(leftMenuData);
        console.log(path);
        this.$router.push(path);
      }
    },

    setShowLeft(isShow) {
      console.log("setShowLeft", isShow);
      this.isShowLeft = isShow;
      if (isShow) {
        let topName = "0" + this.$store.state.ta;
        console.log(topName);
        /*
        let leftMenuData = this.menu[topName].left;
        /*/
        let leftMenuData = this.getLeftMenuData(this.$store.state.ta);
        //*/
        this.leftMenuData = leftMenuData;
      }
    },
    getLeftMenuData(ta) {
      let index = parseInt(ta);
      index--;
      let r = [];
      //console.log("getLeftMenuData", _md, index, _md[index]);
      _.each(_md[index].menu, (item) => {
        //console.log(item);
        let m = item.menu;
        if (m) {
          let c = [];
          _.each(m, (item) => {
            if (!(item.url && item.url.startsWith("/"))) {
              return true;
            }
            c.push({
              id: item.id,
              name: item.title,
              icon: item.gntb,
              path: item.url.substring(1),
            });
          });
          r.push({
            id: item.id,
            name: item.title,
            icon: item.gntb,
            children: c,
          });
        } else {
          if (!(item.url && item.url.startsWith("/"))) {
            console.log("continue", item);
            return true;
          }
          r.push({
            id: item.id,
            name: item.title,
            icon: item.gntb,
            path: item.url.substring(1),
          });
        }
      });
      console.log(JSON.stringify(_md[index].menu, null, 2));
      console.log("-----------------------------");
      console.log(JSON.stringify(r, null, 2));
      return r;
    },
  },
  created() {
    this.userName = sessionStorage.getItem("userName");
  },
  mounted() {
    if (_md) {
      this.$refs.menuTop.setData(_md);
    } else {
      this.$api.call({
        view: this,
        name: "GETMENU",
        success: (result) => {
          console.log(result);
          _md = result;
          sessionStorage.setItem("menu.data", JSON.stringify(result));
          this.$refs.menuTop.setData(_md);
        },
      });
    }
  },
};
export default w;
</script>
<style scoped>
.page-enter {
  height: 100%;
}

.page-enter .header {
  background: #20243f;
  color: #fff;
  height: 67px !important;
}

.page-enter .title {
  font-size: 22px;
  font-family: PingFangSC-Regular;
  font-stretch: normal;
  line-height: 70px;
  vertical-align: middle;
  letter-spacing: 1px;
}

.page-enter .sub-title {
  font-size: 20px;
  font-stretch: normal;
  line-height: 70px;
  border-left: 1px solid hsla(0, 0%, 100%, 0.5);
  padding-left: 10px;
  margin-left: 10px;
  vertical-align: middle;
}

.el-header {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 67px;
}

.user-avatar {
  display: inline-block;
  background: url("../../assets/img/head.png");
  background-position-y: 10px;
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
  width: 40px;
  height: 67px;
  margin-right: 20px;
  color: transparent;
}

.user-name {
  font-size: 14px;
}

.el-aside {
  background: #ccc;
}

.el-main {
  padding: 0;
  /* background-color: rgb(245, 248, 253); */
}
</style>
